import type { FaireProductEntity } from "../../entity_types/product";

export const p_6897jwbhve: FaireProductEntity = {
  token: "p_6897jwbhve",
  type: "product",
  name: "Ojai Lavender– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/1603bbdf04f52b022a3b7d10ea2adee243bc1b5979a19950fa6c04df0ab61852.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ff57146777426d1e6246c009d6973417a98c5da2603c94d84bf3e5a4bbbd664.jpeg",
    "https://cdn.faire.com/fastly/3f91ef78791956f0113a39c9dbb9caf24ad6b2f226357772074b8fe4da9ab0b7.jpeg",
    "https://cdn.faire.com/fastly/932d29730c6e9571593cf2e9fb6d0a90e21d69ca8c4c702f0d34004650b22408.jpeg",
    "https://cdn.faire.com/fastly/7381e25c3260aa5d1a7990687209b9bc0f7b00c3b8ffee010ff420daed9f4b5a.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Sun-drenched fields, orange groves and lavender farms, jagged mountains washed in a rosy, sunset glow. Pixie tangerine, lavender, mint.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:53.165Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
